import Icon from "@mdi/react";
import { Typography } from "@mui/material";

import styles from "./dataIconPlaceholder.module.scss";

export interface DataIconPlaceholderProps {
  icon: string;
  size?: number;
  text: string;
  topPositionPercentage?: number;
}

function DataIconPlaceholder(props: DataIconPlaceholderProps) {
  const { icon, size = 2, text, topPositionPercentage = 50 } = props;

  return (
    <div
      className={styles.root}
      style={{
        top: `${topPositionPercentage}%`,
        transform: `translateY(-${topPositionPercentage}%)`,
      }}
    >
      <Icon path={icon} size={size} />
      <Typography mt={1}>{text}</Typography>
    </div>
  );
}

export default DataIconPlaceholder;
